import { useTranslation } from "react-i18next";
import PhoneInput, { PhoneInputProps } from "react-phone-input-2";
import Text from "@/components/atoms/Text";

import "react-phone-input-2/lib/bootstrap.css";
import "./PhoneInput.css";

interface PhoneFieldProps extends PhoneInputProps {
  errormessage?: string;
  testId?: string;
}

function PhoneField({ errormessage, inputProps: _userInputProps, ...rest }: PhoneFieldProps) {
  const { t } = useTranslation();

  return (
    <div className="phonefield">
      <label>{t("common:phone")}</label>
      <PhoneInput
        inputClass="input"
        prefix="+"
        data-testid={rest.testId}
        countryCodeEditable={true}
        preferredCountries={["no", "us", "se", "dk", "uk"]}
        country="no"
        {...rest}
      />
      {errormessage && (
        <Text c={"error"} size={"sm"}>
          {errormessage}
        </Text>
      )}
    </div>
  );
}

export default PhoneField;
